import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';

@customElement('summary-notice-popup')
export class SummaryNoticePopup extends DeviceAwareComponent {
  static get styles() {
    return [
      commonPopupStyle,
      css`
        #art {
          width: 48%;
          height: 25rem;
        background-image: url(./assets/summary-notice-popup.svg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        margin-bottom: 1rem;
        margin-top: 20%;
      }
      .title {
        font-size: 3rem;
        font-weight: var(--font-weight-emphasize);
        padding-inline: 19%;
        padding-block: 3%;
      }
      .message {

        color: var(--c-select);
        padding-inline: 8%;
      }
      @media screen and  (max-width: 370px) {
         .title {
          padding-inline: 16%;
        }
         .message {
          padding-inline: 7%;
        }
      }
    `,
    ];
  }

  render() {
    return html`
      <div id="art"></div>
      <h1 class="title">${t('T_Summary_Title')}</h1>
      <p class="message">${t('T_Summary_Text')}</p>
    `;
  }
}
